var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page theme-transition"},[_c('BackNavigationBar',{attrs:{"back":_vm.back,"title":_vm.title,"hide-button":_vm.hideBackButton}}),_c('div',{staticClass:"page-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }